module.exports = __webpack_public_path__ + "static/img/13.93baa54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/13.png
// module id = iFsr
// module chunks = 0